import React from 'react';
import { Pagination } from 'rsuite';

export const LIMIT = 10;

export const CustomPagination = (props) => {
  const { totalRecords, limit, page, handleChangePage, handleChangeLimit } = props;
  return (
    <div style={{ padding: 20 }}>
      <Pagination
        prev
        next
        first
        last
        ellipsis
        boundaryLinks
        maxButtons={5}
        size="sm"
        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
        total={totalRecords}
        limitOptions={[10, 30, 50]}
        limit={limit}
        activePage={page}
        onChangePage={handleChangePage}
        onChangeLimit={handleChangeLimit}
      />
    </div>
  );
};
